<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import inboxesAPI from 'dashboard/api/inboxes';

import SettingsFieldSection from 'dashboard/components-next/Settings/SettingsFieldSection.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const props = defineProps({
  inboxId: {
    type: [Number, String],
    required: true,
  },
});

const { t } = useI18n();

const dialogRef = ref(null);
const isRestarting = ref(false);

const handleConfirm = async () => {
  if (isRestarting.value) return;

  isRestarting.value = true;
  try {
    await inboxesAPI.evolutionRestart(props.inboxId);
    useAlert(t('INBOX_MGMT.EVOLUTION_RESTART.SUCCESS_MESSAGE'));
    dialogRef.value?.close();
  } catch {
    useAlert(t('INBOX_MGMT.EVOLUTION_RESTART.ERROR_MESSAGE'));
  } finally {
    isRestarting.value = false;
  }
};
</script>

<template>
  <SettingsFieldSection
    :label="t('INBOX_MGMT.EVOLUTION_RESTART.LABEL')"
    :help-text="t('INBOX_MGMT.EVOLUTION_RESTART.HELP_TEXT')"
  >
    <NextButton
      slate
      icon="i-lucide-refresh-cw"
      :label="t('INBOX_MGMT.EVOLUTION_RESTART.BUTTON_TEXT')"
      @click="dialogRef?.open()"
    />

    <Dialog
      ref="dialogRef"
      :title="t('INBOX_MGMT.EVOLUTION_RESTART.CONFIRM.TITLE')"
      :description="t('INBOX_MGMT.EVOLUTION_RESTART.CONFIRM.DESCRIPTION')"
      :confirm-button-label="t('INBOX_MGMT.EVOLUTION_RESTART.CONFIRM.YES')"
      :cancel-button-label="t('INBOX_MGMT.EVOLUTION_RESTART.CONFIRM.NO')"
      :is-loading="isRestarting"
      @confirm="handleConfirm"
    />
  </SettingsFieldSection>
</template>
